import React, { useState } from 'react';
import './HomePage.css';

const HomePage = ({ onStartSinglePlayer, onStartMultiPlayer }) => {
  const [username, setUsername] = useState('');
  const [learningLanguage, setLearningLanguage] = useState('english');
  
  // Define all language options
  const languageOptions = [
    { id: 'english', name: 'English 🇬🇧' },
    { id: 'japanese', name: 'Japanese 🇯🇵' },
    { id: 'french', name: 'French 🇫🇷' },
    { id: 'spanish', name: 'Spanish 🇪🇸' },
    { id: 'portuguese', name: 'Portuguese 🇵🇹' },
    { id: 'korean', name: 'Korean 🇰🇷' },
    { id: 'german', name: 'German 🇩🇪' },
    { id: 'italian', name: 'Italian 🇮🇹' },
    { id: 'russian', name: 'Russian 🇷🇺' },
    { id: 'arabic', name: 'Arabic 🇸🇦' },
    { id: 'dutch', name: 'Dutch 🇳🇱' },
  ];
  
  const handleStartSinglePlayer = () => {
    if (username.trim() === '') {
      alert('Please enter a username');
      return;
    }
    
    onStartSinglePlayer(username, 0, learningLanguage, 'chinese');
  };
  
  return (
    <div className="homepage-container">
      <h1 className="main-title">Athena Talktastic</h1>
      <p className="subtitle">Multilingual Board Speaking Game</p>
      
      <div className="config-panel" style={{ border: 'none', outline: 'none' }}>
        <div className="user-info-section">
          <h2>Personal Settings</h2>
          
          <div className="input-group">
            <input 
              id="username"
              type="text" 
              placeholder="Enter username" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="username-input"
              maxLength="20"
            />
          </div>
        </div>
        
        <div className="language-section">
          <h2>Learning Language</h2>
          
          <div className="input-group">
            <select 
              id="learning-language"
              value={learningLanguage}
              onChange={(e) => setLearningLanguage(e.target.value)}
              className="language-select"
            >
              {languageOptions.map(option => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="start-section">
          <button 
            className="start-game-button"
            onClick={handleStartSinglePlayer}
          >
            Start Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 